// extracted by mini-css-extract-plugin
module.exports = {"Container":"SuccessScreen_Container__Otttm","Countdown":"SuccessScreen_Countdown__2HdKV"};